/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectPermissionDto } from './projectPermissionDto';
import { SitePermissionDto } from './sitePermissionDto';

export interface PermissionDto {
  roles?: Array<PermissionDto.RolesEnum>;
  sites?: Array<SitePermissionDto>;
  projects?: Array<ProjectPermissionDto>;
}
export namespace PermissionDto {
  export const RolesEnum = {
    Foreman: 'FOREMAN',
    Operator: 'OPERATOR',
  } as const;
  export type RolesEnum = (typeof RolesEnum)[keyof typeof RolesEnum];
}
